<template>
    <div>
        <section id="gradient-section-light" class="corporate-accounts">
            <div class="gst-exclude-banner">
              All prices on page are excluding GST.
              <a :href="$router.resolve({ name: 'content-licence-agreement' }).href" @click.prevent="$bvModal.show('content-licence-agreement-modal')">
                Read Content License Agreement.
              </a>
            </div>
            <div class="container">
                <div class="row">
                    <div id="corporate-heading" class="col-12 text-center">
                        Standard pricing for
                        <nobr>royalty-free</nobr>
                        license.<br class="d-block d-lg-none"> Exclusive licenses available on request.
                      <p class="includes-multi-seat">Our Standard license <strong>includes</strong> Multi-Seat usage within one organisation</p>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12 col-lg-10 offset-lg-1 price-list">
                        <div v-for="price in defaultPrices" :key="price.id">
                            <span class="large btn-color">{{ price.size.toUpperCase() }} {{ moneyOptionalDecimal(price.amount) }}</span>
                            <span class="small text-color">{{ dimensions[price.size].length }}px / {{ dimensions[price.size].dpi }}dpi</span>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>
<script>
import { mapGetters } from 'vuex'

export default {
    name: 'AusPricing',
    props: {
        prices: {
            type: Array,
            default () {
                return []
            }
        }
    },
    data () {
        return {
            dimensions: {
                s: {
                    length: 850,
                    dpi: 72
                },
                m: {
                    length: '1,600',
                    dpi: 72
                },
                l: {
                    length: '2,600',
                    dpi: 300
                },
                xl: {
                    length: '5,000',
                    dpi: 300
                }
            }
        }
    },
    computed: {
        ...mapGetters({
            licences: 'data/licences'
        }),
        defaultPrices () {
            const defaultLicence = this.licences.image.find(licence => licence.default === 1)
            const defaultPriceTier = defaultLicence.tiers.find(tier => tier.default === 1)

            return this.prices.filter(price => price.default === 1 &&
                price.stock_licence_id === defaultLicence.id &&
                price.stock_price_tier_id === defaultPriceTier.id &&
                price.amount !== null
            )
        }
    }
}
</script>
